import { Panel, PanelProps } from "capitalrx-components-2.0/lib/general";
import { CSSProperties, PropsWithChildren } from "react";

export const Card = (props: PropsWithChildren<PanelProps & { noPadding?: boolean; fullHeight?: boolean }>) => {
  const { children, noPadding, fullHeight, style, ...panelProps } = props;

  const themedStyle: CSSProperties = {
    ...(style || {}),
    ...(fullHeight ? { height: "100%" } : {}),
    ...(noPadding ? { padding: "0" } : {}),
  };

  return <Panel {...panelProps} style={themedStyle}>{children}</Panel>;
};
